// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Facet.scss
// module id = 541
// module chunks = 1 4 5 6 7 88